import {Component, h} from 'preact';
import 'jquery-file-download';
import constants from "../../constants";
import ShareOptions from "../header/ShareOptions";
import {connect} from "react-redux";
import reduce from "../../reducers";
import * as actions from "../../actions";
import MOBackIcon from "../svg/MOBackIcon";

export default @connect(reduce, actions)
class MenuShare extends Component {

    constructor() {
        super();

        this.state = {
            isActionSubview: false
        }
    }
  onViewChange(isActionSubview) {
        this.setState({isActionSubview});
  }


  render(props, state) {
    return (
      <div>
        {!this.state.isActionSubview && <header className={'sb'}>
          <a onClick={props.toRoot}>
           <MOBackIcon/>
          </a>
          <h2>Share My Design</h2>
        </header>}
        <div className={`${props.isDigitalMenuBoard ? 'digiboard' : ''}`}>
          <ShareOptions {...props} onViewChange={this.onViewChange.bind(this)}/>
        </div>
      </div>
    )
  }
}
